<template>
  <span v-if="iso" class="fi" :class="flagIconClass" :title="title || iso">
  </span>
</template>

<script>
import "flag-icons/css/flag-icons.min.css";
export default {
  name: "flag",
  props: {
    iso: { type: String, default: null },
    title: { type: String, default: null },
    squared: { type: Boolean, default: true },
  },
  computed: {
    flagIconClass() {
      return `fi-${this.iso.toLowerCase()} ${Boolean(this.squared) ? "fis " : ""}`;
    },
  },
};
</script>

<style>
</style>
